import React from 'react';
import './ErrorModal.css';

const ErrorModal = ({ isOpen, onClose, output, expectedOutput }) => {
  if (!isOpen) return null;

  return (
    <div className="error-modal-overlay" onClick={onClose}>
      <div className="error-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="error-modal-content__glass">
          <div className="error-modal-body">
            <h2 className="error-title" id="error-modal-title">
              INCORRECT
            </h2>

            <div className="error-details" role="region" aria-labelledby="error-modal-title">
              <div className="output-comparison">
                <div className="output-section output-section--yours">
                  <h4 className="output-section__label">Your output</h4>
                  <div className="output-box your-output">
                    {output || 'No output received'}
                  </div>
                </div>

                <div className="output-section output-section--expected">
                  <h4 className="output-section__label">Expected output</h4>
                  <div className="output-box expected-output">
                    {expectedOutput || 'Check the problem description'}
                  </div>
                </div>
              </div>
            </div>

            <div className="error-actions">
              <button type="button" className="sign-in-btn" onClick={onClose}>
                Try Again
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
